module.exports = __webpack_public_path__ + "static/img/avatar.e40c4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/masterCenter/avatar.png
// module id = cxMC
// module chunks = 1